import { render, staticRenderFns } from "./RewardsView.vue?vue&type=template&id=643fc58a"
import script from "./RewardsView.vue?vue&type=script&lang=js"
export * from "./RewardsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports